import React from 'react';
import { Helmet } from 'react-helmet-async';
import GearRental1 from '../assets/Services/GearRental.png';
import ChildServiceLayout from '../components/ChildServiceLayout';
import '../styles/ServicesPage.css'
import { Link } from 'react-router-dom';

export default function GearRentalPage() {
  return (
    <>
      <Helmet>
        <title>Audio & Music Gear Rentals | Westchester NY</title>
        <meta name="description" content="Affordable music gear rentals in Westchester, serving Rye and Port Chester." />
      </Helmet>

      <ChildServiceLayout
        title="Professional Gear Rental"
        intro="We offer professional-grade live sound equipment for events, performances, and private functions."
        image={GearRental1}
        cta={{
          heading: 'Book Your Gear',
          text: 'Let us know what you need, and we’ll tailor the perfect rental package for you.',
          link: { href: '/contact', text: 'Get a Quote' }
        }}
      >
        <h2>What We Offer</h2>
        <ul>
          <li><strong>PA Systems</strong> – For small to mid-sized venues</li>
          <li><strong>Subwoofers & Monitors</strong> – Deep bass, clear sound</li>
          <li><strong>Mixing Consoles</strong> – Seamless sound control</li>
          <li><strong>Microphones & Stands</strong> – Wired & wireless options</li>
          <li><strong>Cables & Accessories</strong> – Everything you need</li>
        </ul>
        <p>
          Need an expert? Hire an <Link to="/services/live-sound/audio-engineer">Audio Engineer</Link> for flawless sound management.
        </p>
      </ChildServiceLayout>
    </>
  );
}
